import { CHANGE_CONFIG } from '../constants';
export const config = (state = {
    default: {},
    templates: {},
}, action) => {
    switch (action.type) {
        case CHANGE_CONFIG:
            return {
                ...state,
                ...action.config,
            };
        default:
            return state;
    }
};
//# sourceMappingURL=config.js.map